<div class="flex h-full flex-col">
  <mat-sidenav-container class="shell-container h-full" [hasBackdrop]="false">
    <!-- Left Sidenav (Main Navigation) -->
    <mat-sidenav mode="side" [opened]="state.showSidenav" [disableClose]="true" class="border-r border-neutral-200">
      <div class="flex h-full flex-col">
        <!-- Logo Section -->
        <div class="flex w-full items-center justify-center px-6 pt-5">
          <img src="./assets/images/dojostack-logo.svg" alt="DojoStack" class="h-8" />
        </div>

        <div class="flex w-full flex-col items-start p-4">
          <div class="flex w-full flex-col gap-0.5">
            <!-- Overview Link -->
            <a
              [routerLink]="['/overview']"
              routerLinkActive="active"
              class="sidebar-link text-secondary flex w-full items-center truncate px-2 py-1.5 text-sm font-medium"
              #overviewRla="routerLinkActive"
            >
              <dojo-icon
                [icon]="'bullseye'"
                [iconClass]="overviewRla.isActive ? 'text-sky-500' : 'text-secondary'"
                [size]="12"
                class="mr-1.5"
              />
              <span class="truncate">Overview</span>
            </a>

            <!-- Payment Link -->
            <a
              [routerLink]="['/payment']"
              routerLinkActive="active"
              class="sidebar-link text-secondary flex w-full items-center truncate px-2 py-1.5 text-sm font-medium"
              #paymentRla="routerLinkActive"
            >
              <dojo-icon
                [icon]="'credit-card'"
                [iconClass]="paymentRla.isActive ? 'text-sky-500' : 'text-secondary'"
                [size]="12"
                class="mr-1.5"
              />
              <span class="truncate">Payment</span>
            </a>

            <!-- Profile Link -->
            <a
              [routerLink]="['/profile']"
              routerLinkActive="active"
              class="sidebar-link text-secondary flex w-full items-center truncate px-2 py-1.5 text-sm font-medium"
              #profileRla="routerLinkActive"
            >
              <dojo-icon
                [icon]="'user'"
                [iconClass]="profileRla.isActive ? 'text-sky-500' : 'text-secondary'"
                [size]="12"
                class="mr-1.5"
              />
              <span class="truncate">Profile</span>
            </a>
          </div>
        </div>

        <div class="mt-auto flex w-full flex-col gap-1 p-4">
          <!-- Help Button -->
          <button
            (click)="toggleHelpSidenav()"
            class="sidebar-link text-secondary flex w-full items-center truncate px-2 py-1.5 text-sm font-medium"
          >
            <dojo-icon [icon]="'question-circle'" [iconClass]="'text-secondary'" [size]="12" class="mr-1.5" />
            <span class="truncate">Help</span>
          </button>

          @if (state.isLoading) {
            <div class="text-secondary flex w-full items-center gap-2 px-2 py-1.5">
              <div class="h-5 w-5 animate-spin rounded-full border-2 border-current border-t-transparent"></div>
              <span class="text-sm">Loading...</span>
            </div>
          } @else {
            <a
              [matMenuTriggerFor]="userMenu"
              class="text-secondary flex w-full max-w-full items-center gap-2 rounded-[0.75rem] px-2 py-1.5 font-semibold transition-colors hover:bg-neutral-50 group-[.is-compact]:px-2"
            >
              <dojo-profile-avatar [size]="20" class="shrink-0" />
              <span class="truncate text-sm">{{ state.user?.fullName }}</span>
            </a>
          }
        </div>
      </div>
    </mat-sidenav>

    <!-- Help Sidenav (Right Side) -->
    <mat-sidenav
      mode="over"
      position="end"
      [opened]="showHelpSidenav()"
      (openedChange)="onHelpSidenavOpenedChange($event)"
      class="help-sidenav border-l border-neutral-200"
    >
      <div class="flex h-full flex-col p-6">
        <div class="flex items-center justify-between">
          <h2 class="text-lg font-semibold">Help</h2>
          <dojo-icon-button class="inline-flex" [size]="'xs'" [icon]="'times'" (click)="closeHelpSidenav()" />
        </div>
        <div class="flex flex-1 flex-col gap-3 pt-4">
          <!-- Onboarding -->
          <a
            href="https://www.notion.so/dojostack/AI-Content-Expert-Onboarding-279b7b3bb4668062bc17fea5f313163d"
            target="_blank"
            rel="noopener noreferrer"
            class="block w-full"
          >
            <dojo-button [fill]="'outline'" [size]="'l'" class="w-full">
              <dojo-icon [icon]="'rocket'" class="mr-2" [size]="18" />
              <span>Onboarding</span>
              <dojo-icon [icon]="'arrow-up-right-from-square'" class="ml-2" [size]="16" />
            </dojo-button>
          </a>

          <!-- Working Hours & Payment -->
          <a
            href="https://www.notion.so/dojostack/Working-Hours-Payment-Guidelines-279b7b3bb46680ec8133cacd259495c0"
            target="_blank"
            rel="noopener noreferrer"
            class="block w-full"
          >
            <dojo-button [fill]="'outline'" [size]="'l'" class="w-full">
              <dojo-icon [icon]="'credit-card'" class="mr-2" [size]="18" />
              <span>Working Hours & Payment</span>
              <dojo-icon [icon]="'arrow-up-right-from-square'" class="ml-2" [size]="16" />
            </dojo-button>
          </a>

          <!-- Labelling Help Docs -->
          <a
            href="https://www.notion.so/dojostack/Labelling-Help-Docs-218b7b3bb46680468a09edc0c6c9e666"
            target="_blank"
            rel="noopener noreferrer"
            class="block w-full"
          >
            <dojo-button [fill]="'outline'" [size]="'l'" class="w-full">
              <dojo-icon [icon]="'book'" class="mr-2" [size]="18" />
              <span>Labelling Help Docs</span>
              <dojo-icon [icon]="'arrow-up-right-from-square'" class="ml-2" [size]="16" />
            </dojo-button>
          </a>
        </div>
      </div>
    </mat-sidenav>

    <mat-sidenav-content class="!overflow-hidden bg-white">
      <div class="h-full overflow-y-auto">
        <router-outlet></router-outlet>
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>

<mat-menu #userMenu="matMenu" class="custom-mat-menu">
  <button mat-menu-item (click)="signOut()">
    <dojo-icon class="menu-icon" [icon]="'arrow-right-from-bracket'" />
    <span class="menu-item-label">{{ 'examdojo.registration.sign_out' | transloco }}</span>
  </button>
</mat-menu>
